import { NotificationManager } from 'react-notifications'
import { getData, sendData } from './apiService.js'
import { storeCache, removeCache } from './../lib/cache.js'
export async function login(values) {
  let response = await sendData('login', values)
  if (response.success) {
    storeCache('token', response.data.token)
    let yourData = await getData('your')
    if (!yourData.success) {
      NotificationManager.error(yourData.message)
    }
    NotificationManager.success('Success')
    if (yourData.data.user.role == 5) {
      if (yourData.data.user.project == 2) {
        yourData.data.user.township_group_id += 2
      }
    }

    storeCache('userData', JSON.stringify(yourData.data.user))
    return yourData.data.user
  } else {
    NotificationManager.error(response.message)
  }
  return false
}

export function logout() {
  removeCache('token')
  removeCache('userData')
  NotificationManager.success('Logout')
  return true
}
